import { render, staticRenderFns } from "./LinkDownload.vue?vue&type=template&id=6d581517&scoped=true"
import script from "./LinkDownload.vue?vue&type=script&lang=js"
export * from "./LinkDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d581517",
  null
  
)

export default component.exports